import { StageDataField } from '@Components/Flows';
import { useSubscription } from '@Hooks/useSubscription';
import { formatCurrency, formatDateWithTime } from '@Utils/utils';

export function StageContentRegistration({ fish }) {
  const subscriptionId = fish?.subscriptions?.[0]?.id;

  const { data: subscription } = useSubscription({
    subscriptionId,
    include:
      'subscriptionTier,purchase,registrationCode,referral.fish.fishProfiles,referral.registrationCode',
    enabled: !!subscriptionId,
  });

  const deletedAt = subscription?.deletedAt ?? null;
  const cancelledAt = subscription?.cancelledAt ?? null;

  const subscriptionType = subscription?.subscriptionType ?? 'N/A';
  const subscriptionTier = subscription?.subscriptionTier?.title ?? 'N/A';
  const subscriptionTierDescription =
    subscription?.subscriptionTier?.description ?? 'N/A';

  const purchase = subscription?.purchase?.reduce((latest, current) => {
    if (current.purchaseType !== 'SUBSCRIPTION') return latest;

    if (!latest) return current;

    return new Date(current.updatedAt) > new Date(latest.updatedAt)
      ? current
      : latest;
  }, null);

  const purchaseCreatedAt = formatDateWithTime(purchase?.createdAt) ?? 'N/A';
  const purchaseConfirmationNumber = purchase?.confirmationNumber ?? 'N/A';
  const purchaseOriginalPrice =
    formatCurrency(purchase?.originalPrice) ?? 'N/A';
  const purchasePrice = formatCurrency(purchase?.price) ?? 'N/A';

  const registrationCode = subscription?.registrationCode?.code ?? 'N/A';
  const registrationCodeDetails =
    subscription?.registrationCode?.promoDetails ?? 'N/A';

  const referralFish = subscription?.referral?.fish;
  const referralFishProfile =
    referralFish?.fishProfiles?.find((fp) => fp.profileType === 'MEMBER') ??
    referralFish?.fishProfiles?.[0];

  const referralFishName = referralFishProfile
    ? `${referralFishProfile.fName} ${referralFishProfile.lName}`
    : 'N/A';

  const referralCode = subscription?.referral?.registrationCode?.code ?? 'N/A';

  return (
    <div className="flex flex-col gap-3">
      {(deletedAt || cancelledAt) && (
        <>
          {cancelledAt && (
            <div className="break-word w-1/2">
              <StageDataField
                label={'Cancelled on'}
                value={cancelledAt}
                labelClassName={'text-red-500'}
              />
            </div>
          )}

          {deletedAt && (
            <div className="break-word w-1/2">
              <StageDataField
                label={'Deleted on'}
                value={deletedAt}
                labelClassName={'text-red-500'}
              />
            </div>
          )}

          {/* horizontal line */}
          <div className="my-4 h-px w-full bg-zinc-200" />
        </>
      )}

      <div className="break-word w-1/2">
        <StageDataField label={'Subscription Type'} value={subscriptionType} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Subscription Tier'} value={subscriptionTier} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Tier Description'}
          value={subscriptionTierDescription}
        />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField label={'Purchase Date'} value={purchaseCreatedAt} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Purchase Confirmation Number'}
          value={purchaseConfirmationNumber}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Original Price'}
          value={purchaseOriginalPrice}
        />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Amount Paid'} value={purchasePrice} />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField label={'Registration Code'} value={registrationCode} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField
          label={'Registration Code Details'}
          value={registrationCodeDetails}
        />
      </div>

      {/* horizontal line */}
      <div className="my-4 h-px w-full bg-zinc-200" />

      <div className="break-word w-1/2">
        <StageDataField label={'Referred By'} value={referralFishName} />
      </div>

      <div className="break-word w-1/2">
        <StageDataField label={'Referred Code'} value={referralCode} />
      </div>
    </div>
  );
}
